/* eslint-disable react-hooks/exhaustive-deps */
import { Spin, Tag, Timeline } from 'antd';
import classNames from 'classnames';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import IconEmpty from '../../../assets/Images/icons/empty';
import { ROUTER } from '../../../constants/router';
import {
    DonwloadTemplateHR,
    DonwloadTemplatePrivacy,
    DonwloadTemplateRecruitment,
    DonwloadTemplateVendor,
    DonwloadTemplateCCTV,
    DonwloadTemplateDPA,
    DownloadFreeForm,
} from './DownloadCenter';
import { useEffect, useState } from 'react';
import usePermission from '../../../hooks/usePermission';

export default function HistoryDrawer({
    historyResultIdName,
    historyParamName,
    type,
    serviceHistory,
    data,
    privacyId,
    visible,
}) {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    const { isAuditor } = usePermission();

    const _getTagStatus = (e) => {
        switch (e?.status) {
            case 'Draft':
                return (
                    <Tag
                        className="rounded-xl -my-1 text-center px-4"
                        style={{ color: '#9A9A9A', borderColor: '#9A9A9A' }}
                    >
                        {e?.status} {e?.version}
                    </Tag>
                );
            case 'Published':
                return (
                    <Tag
                        className="rounded-xl -my-1 text-center px-4 text-white"
                        style={{ color: '#4ACE8F', borderColor: '#4ACE8F' }}
                    >
                        {e?.status} {e?.latestPublishVersion}
                    </Tag>
                );
            default:
                return '-';
        }
    };

    // History
    const [histories, setHistories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);

    const getHistory = async (params) => {
        if (data) {
            setLoading(true);
            try {
                setTimeout(async () => {
                    setLoading(false);
                    const { data } = await serviceHistory(params);
                    if (data?.resultData) {
                        if (params.p === 1) {
                            setHistories(data.resultData?.result);
                            setPage(2);
                        } else {
                            const history = histories.concat(
                                data.resultData?.result
                            );
                            setHistories(history);
                            setPage(page + 1);
                        }
                        setTotal(data?.resultData?.total);
                        setLoading(false);
                    }
                }, 300);
            } catch (error) {
                setLoading(false);
                console.log(error);
            }
        }
    };

    useEffect(() => {
        if (data[privacyId] && visible) {
            const params = {
                [historyParamName]: data[privacyId],
                p: 1,
                ps: 10,
                sd: 'DESC',
            };
            setHistories([]);
            getHistory(params);
        }
    }, [data[privacyId], visible]);

    const scrollEvent = (e) => {
        const scrollTop = e.target.scrollTop;
        const scrollHeight = e.target.scrollHeight - e.target.clientHeight;
        const threshold = scrollHeight * 0.9; // 90% of the total height
        if (scrollTop >= threshold && total > histories.length && !loading) {
            const params = {
                [historyParamName]: data[privacyId],
                p: page,
                ps: 10,
                sd: 'DESC',
            };
            getHistory(params);
        }
    };

    return (
        <Timeline>
            <Spin spinning={loading}>
                <div
                    onScroll={scrollEvent}
                    className="h-[95vh] overflow-y-scroll p-4 pb-12"
                >
                    {histories.length > 0 ? (
                        histories.map((item, i) => (
                            <Timeline.Item
                                color={i === 0 ? '#F0536F' : '#3699FF'}
                                key={i}
                            >
                                <button
                                    className={classNames(
                                        'bg-[#EDEEF9] px-2 pt-4 pb-2 rounded-t-lg space-y-3 cursor-pointer hover:opacity-90 text-left w-full',
                                        { 'bg-[#F4F6FC]': i !== 0 }
                                    )}
                                    onClick={() => {
                                        navigate(
                                            `${ROUTER.POLICY.HISTORY}/${item[historyResultIdName]}/${type}`
                                        );
                                    }}
                                >
                                    <div className="grid grid-cols-3 text-xs">
                                        <div className="col-span-1 font-semibold">
                                            {t('LogDate')} :
                                        </div>
                                        <div className="col-span-2">
                                            {item?.logDate || '-'}
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-3 text-xs">
                                        <div className="col-span-1 font-semibold">
                                            {t('Update By')} :
                                        </div>
                                        <div className="col-span-2">
                                            {item?.updateBy || '-'}
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-3 text-xs">
                                        <div className="col-span-1 font-semibold">
                                            {t('Version')} :
                                        </div>
                                        <div className="col-span-2">
                                            {item?.version || '-'}
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-3 text-xs">
                                        <div className="col-span-1 font-semibold">
                                            {t('Action')} :
                                        </div>
                                        <div className="col-span-2">
                                            <span>
                                                <Tag
                                                    className="rounded-xl -my-1 text-center px-4 text-white"
                                                    color="#7B67FB"
                                                >
                                                    {i18n.language === 'en'
                                                        ? item?.action
                                                        : item?.action}
                                                </Tag>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-3 text-xs">
                                        <div className="col-span-1 font-semibold">
                                            {t('Status')} :
                                        </div>
                                        <div className="col-span-2">
                                            <span>{_getTagStatus(item)}</span>
                                        </div>
                                    </div>
                                </button>
                                <div
                                    hidden={isAuditor}
                                    className={classNames(
                                        'grid grid-cols-3 text-xs relative bg-[#EDEEF9] px-2 pb-2 rounded-b-lg  cursor-pointer hover:opacity-90',
                                        { 'bg-[#F4F6FC]': i !== 0 }
                                    )}
                                >
                                    <div
                                        hidden={type === 'cookie'}
                                        className="col-span-1 font-semibold"
                                    >
                                        {t('policy.Downloadfile')} :
                                    </div>
                                    {(() => {
                                        switch (type) {
                                            case 'privacy':
                                                return (
                                                    <DonwloadTemplatePrivacy
                                                        detail={item.data}
                                                        version={item.version}
                                                        t={t}
                                                    />
                                                );
                                            case 'hr':
                                                return (
                                                    <DonwloadTemplateHR
                                                        detail={item.data}
                                                        version={item.version}
                                                        t={t}
                                                    />
                                                );
                                            case 'recruitment':
                                                return (
                                                    <DonwloadTemplateRecruitment
                                                        detail={item.data}
                                                        version={item.version}
                                                        t={t}
                                                    />
                                                );
                                            case 'vendor':
                                                return (
                                                    <DonwloadTemplateVendor
                                                        detail={item.data}
                                                        version={item.version}
                                                        t={t}
                                                    />
                                                );
                                            case 'cctv':
                                                return (
                                                    <DonwloadTemplateCCTV
                                                        detail={item.data}
                                                        version={item.version}
                                                        t={t}
                                                    />
                                                );
                                            case 'dpa':
                                                return (
                                                    <DonwloadTemplateDPA
                                                        detail={item.data}
                                                        version={item.version}
                                                        t={t}
                                                    />
                                                );
                                            case 'freeForm':
                                                return (
                                                    <DownloadFreeForm
                                                        detail={item.data}
                                                        version={item.version}
                                                        t={t}
                                                    />
                                                );
                                            default:
                                                return null;
                                        }
                                    })()}
                                </div>
                            </Timeline.Item>
                        ))
                    ) : (
                        <div className="h-[30vh] grid items-center justify-center">
                            <div className="-mt-16">
                                <IconEmpty />
                            </div>
                        </div>
                    )}
                </div>
            </Spin>
        </Timeline>
    );
}
